export const imagePath = {
  appImage: "/app/cover_image/${content}",
  styleImage: "/style/cover_image/${content}",
  controlNetImage: "/control_net/cover_image/${content}",
  appForm: "/app_${content}/form/",
  userAvatar: "/user/image/${content}"
};